import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonItem, IonLabel, IonList, IonNote } from "@ionic/react";
import BackfillAssignmentStatuses from "./BackfillAssignmentStatuses";
import BackfillDefaultPrePostAssignments from "./BackfillDefaultPrePostAssignments";
import BackfillDefaultQuizStandard from "./BackfillDefaultQuizStandard";
import BackfillInitializeIrtQuestions from "./BackfillInitializeIrtQuestions";
import BackfillNormalizeQuizQuestionReferences from "./BackfillNormalizeQuizQuestionReferences";
import BackfillRemoveImpliedQuizQuestionLinks from "./BackfillRemoveImpliedQuizQuestionLinks";

const BackfillUtilities: React.FC = () => {
  return (
    <>
      <IonCard>
        <IonCardHeader>
          <IonCardTitle>Backfill Utilities</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <IonList>
            <IonItem>
              <IonLabel>Default Quiz Standard Backfill</IonLabel>
              <IonNote slot="end">Ready</IonNote>
            </IonItem>
            <IonItem>
              <IonLabel>Normalize Quiz Question References</IonLabel>
              <IonNote slot="end">Ready</IonNote>
            </IonItem>
            <IonItem>
              <IonLabel>Remove Implied Quiz Question Links</IonLabel>
              <IonNote slot="end">Ready</IonNote>
            </IonItem>
            <IonItem>
              <IonLabel>Pre/Post-test Assignment Backfill</IonLabel>
              <IonNote slot="end">Ready</IonNote>
            </IonItem>
            <IonItem>
              <IonLabel>IRT Question Initialization</IonLabel>
              <IonNote slot="end">Ready</IonNote>
            </IonItem>
            <IonItem>
              <IonLabel>Assignment Status Deduplication</IonLabel>
              <IonNote slot="end">Ready</IonNote>
            </IonItem>
          </IonList>
        </IonCardContent>
      </IonCard>

      <BackfillAssignmentStatuses />
      <BackfillDefaultPrePostAssignments />
      <BackfillDefaultQuizStandard />
      <BackfillInitializeIrtQuestions />
      <BackfillNormalizeQuizQuestionReferences />
      <BackfillRemoveImpliedQuizQuestionLinks />
    </>
  );
};

export default BackfillUtilities;
